// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__JkXQC","show":"banner_show__w-BQM"};